module.exports = __webpack_public_path__ + "img/Atopie_logo.c9755830.svg";